<div class="modal-container">
    <ng-container #vc></ng-container>
</div>